<template>
    <div class="page_home_hx flex-col">

        <div class="group_186 flex-col">
            <div class="map_title">
                <span class="text_87">遍布全国的办事处</span>
            </div>
            <div class="box_43 flex-row justify-between">
                <img
                        class="image_22"
                        referrerpolicy="no-referrer"
                        src="../../../assets/index/chpc_index.map.png"
                />

            </div>
            <div class="block_97 flex-col">

                <div class="image-text_272 flex-row justify-between">
                    <img
                            class="label_12"
                            referrerpolicy="no-referrer"
                            src="../../../assets/contact/contact_address.png"
                    />
                    <span class="text-group_34">北京总公司</span>
                </div>
                <span class="paragraph_10" v-html="companyItem.bj"></span>
                <span class="text_88">电话：010-58204887，传真：010-58204839</span>
                <div class="image-text_273 flex-row justify-between">
                    <img
                            class="label_12"
                            referrerpolicy="no-referrer"
                            src="../../../assets/contact/contact_address.png"
                    />
                    <div class="text-group_372 flex-col">
                        <span class="text_89">上海分公司</span>
                        <span class="paragraph_11" v-html="companyItem.sh"></span>
                        <span class="text_90">电话：021-63331086</span>
                    </div>
                </div>
                <div class="image-text_274 flex-row justify-between">
                    <img
                            class="label_12"
                            referrerpolicy="no-referrer"
                            src="../../../assets/contact/contact_address.png"
                    />
                    <div class="text-group_373 flex-col justify-between">
                        <span class="text_91">各地办事处</span>
                        <span class="text_92">
                武汉&nbsp;•&nbsp;广州&nbsp;•&nbsp;南京&nbsp;•&nbsp;成都&nbsp;•&nbsp;天津&nbsp;•&nbsp;合肥&nbsp;•&nbsp;无锡&nbsp;•&nbsp;西安
              </span>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

    export default {
        props: {

        },
        data() {
            return {
                companyItem :{
                    bj:'北京市朝阳区建国路93号院万达广场8号楼2606室' + '<br />' +
                        'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,Chaoyang&nbsp;District,Beijing&nbsp;100022,P.R.China',
                    sh: '上海市黄浦区蒙自路757号平安滨江金融中心30层3001室' +
                        '<br />' +
                        'Suite&nbsp;3001,&nbsp;30/F,&nbsp;Ping&nbsp;An&nbsp;Binjiang&nbsp;Financial&nbsp;Center,&nbsp;No.&nbsp;757&nbsp;Mengzi&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,&nbsp;P.R.China'
                },
                companyItemMobile :{
                    bj:'北京市朝阳区建国路93号院万达广场8号楼2606室' + '<br />' +
                        'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,' + '<br />' +
                        'Chaoyang&nbsp;District,Beijing&nbsp;100022,P.R.China',
                    sh: '上海市黄浦区蒙自路757号平安滨江金融中心30层3001室' +
                        '<br />' +
                        'Suite&nbsp;3001,&nbsp;30/F,&nbsp;Ping&nbsp;An&nbsp;Binjiang&nbsp;Financial&nbsp;Center,&nbsp;No.&nbsp;757&nbsp;' + '<br />' +
                        'Mengzi&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,&nbsp;P.R.China'
                },
            };
        },
        mounted() {
            //this.getPic();
            this.setContactData();
            window.addEventListener('resize', this.setContactData);
        },
        methods: {
            setContactData() {

                if (window.innerWidth <= 650) { // 假设 768px 以下为移动端
                    this.companyItem = this.companyItemMobile;
                    console.log(this.companyItem)
                } else {
                    //this.contactData = this.contactDataDesktop;

                }
            },
        },
        watch: {
        }
    };
</script>

<style scoped lang="css"  >

    .page_home_hx {
        display: flex !important;
        flex-direction: column;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }


    .group_186 {
        max-width: 100%;
        margin: 0 auto;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .box_43 {
        max-width: 1200px;
        width: 95%;
        height: 437px;
        background: url(../../../assets/index/chpc_home_main_01.png) 100% no-repeat;
        background-size: 100% 100%;
        justify-content: center;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_22 {
        width: 100%;
        max-width: 592px;
        height: 437px;
        object-fit: contain;
        margin: 0;
    }

    .block_97 {
        width: 100%;
        max-width: 1200px;
        height: 469px;
        margin: -20px auto 0;
        width: fit-content;
    }
    .block_97 .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_87 {
        width: 100%;
        max-width: 1200px;
        height: 50px;
        overflow-wrap: break-word;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        white-space: nowrap;
        font-weight: 600;
        font-size: 36px;
        color: #12141C;
        line-height: 50px;
        font-style: normal;

        text-align: center;
        margin: 0 auto;
        display: block;
    }

    .image-text_272 {
        width: 136px;
        height: 31px;
        margin-top: 27px;
    }


    .text-group_34 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .paragraph_10 {
        width: 100%;
        max-width: 484px;
        height: 66px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        text-align: left;
        line-height: 22px;
        margin: 8px 0 0 36px;
    }

    .text_88 {
        width: 336px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 12px 0 0 37px;
    }

    .image-text_273 {
        width: 100%;
        max-width: 510px;
        height: 140px;
        margin-top: 26px;
    }

    .label_11 {
        width: 22px;
        height: 30px;
    }

    .text-group_372 {
        width: 100%;
        max-width: 474px;
        height: 139px;
        margin-top: 1px;
    }

    .text_89 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .paragraph_11 {
        width: 100%;
        max-width: 488px;
        height: 66px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        text-align: left;
        line-height: 22px;
        margin-top: 11px;
    }

    .text_90 {
        width: 157px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 12px 0 0 1px;
    }

    .image-text_274 {
        width: 100%;
        max-width: 423px;
        height: 62px;
        margin-top: 25px;
    }

    .label_12 {
        width: 22px;
        height: 30px;
    }

    .text-group_373 {
        width: 387px;
        height: 61px;
        margin-top: 1px;
    }

    .text_91 {
        width: 100px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 20px;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
    }

    .text_92 {
        width: 387px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin-top: 11px;
    }

    @media (min-width: 431px) and (max-width: 650px){

        .paragraph_10, .paragraph_11 {
            width: 360px;
            font-size: 12px;

        }
        .label_12 {
            width: 18px;
            height: 26px;
        }
        .block_97 {
            width: 100%;
            max-width: 1200px;
            height: 420px;
            margin: -50px auto 0;
            width: fit-content;
        }
        .paragraph_10, .paragraph_11 {
            width: 340px;
            font-size: 11px;
        }
        .text_88 {
            width: 330px;
            font-size: 13px;
        }
        .text_90 {
            font-size: 13px;
            margin-left: 10px;
        }
        .text_92 {
            font-size: 13px;
        }
        .text_87 {
            font-size: 25px;
        }
        .box_43 {
            margin-top: -60px;
        }

        .text_89 {
            margin-left: 10px;
        }
        .text_91{
            margin-left: 10px;
        }
        .text-group_34 {
            margin-left: -8px;
        }
        .image-text_272 {
            width: 130px;
        }
        .paragraph_10 {
            margin: 8px 0 0 30px;
        }
        .paragraph_11 {
            margin: 8px 0 0 10px;
        }
        .text_88 {
            margin: 12px 0 0 30px;
        }
        .text_92 {
            font-size: 13px;
            margin-left: 10px;
        }
    }
    @media (max-width: 430px) {

        .label_12 {
            width: 18px;
            height: 28px;
        }
        .block_97 {
            width: 100%;
            max-width: 1200px;
            height: 420px;
            margin: -50px auto 0;
            width: fit-content;
        }
        .paragraph_10, .paragraph_11 {
            width: 330px;
            font-size: 12px;
        }
        .text_88 {
            width: 320px;
            font-size: 13px;
        }
        .text_90 {
            font-size: 13px;
            margin-left: 10px;
        }

        .text_87 {
            font-size: 25px;
        }
        .box_43 {
            margin-top: -60px;
        }

        .text_89 {
            margin-left: 10px;
        }
        .text_91{
            margin-left: 10px;
        }
        .text-group_34 {
            margin-left: -8px;
        }
        .image-text_272 {
            width: 130px;
        }
        .paragraph_10 {
            margin: 8px 0 0 30px;
        }
        .paragraph_11 {
            margin: 8px 0 0 10px;
        }
        .text_88 {
            margin: 12px 0 0 30px;
        }
        .text_92 {
            font-size: 12px;
            margin-left: 10px;
        }
    }



</style>
